// extracted by mini-css-extract-plugin
export var accordion = "_d7-0";
export var chevron = "_d7-3";
export var closed = "_d7-2";
export var content = "_d7-4";
export var open = "_d7-1";
export var rotate = "_d7-5";